import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Info, FileText, Car, CreditCard, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      
      {/* Hero Section MAI COMPACT */}
      <div className="relative rounded-xl overflow-hidden shadow-lg -mt-2 border border-slate-200">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1523292562811-8fa7962a78c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxnb3Zlcm5tZW50JTIwYnVpbGRpbmd8ZW58MHx8fHwxNzgwMTUxMjczfDA&ixlib=rb-4.1.0&q=85')" }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-r from-[#001B3A]/95 via-[#002B5C]/85 to-[#001B3A]/90 backdrop-blur-[1px]"></div>

        <div className="relative z-10 px-6 py-8 md:py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          
          <div className="flex-1 text-center md:text-left">
            <h1 className="text-2xl md:text-4xl font-extrabold text-white leading-tight mb-3 drop-shadow-md">
              Programări online rapide și sigure
            </h1>
            <p className="text-blue-100 text-sm md:text-base mb-6 max-w-lg leading-relaxed">
              Evitați cozile la ghișee. Sistemul vă permite să alegeți data și ora exactă pentru depunerea dosarului de înmatriculare sau preschimbare a permisului.
            </p>
            <Link to="/rezervari" className="inline-flex items-center justify-center gap-2 bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-bold px-6 py-3 rounded-lg shadow-md transition-transform hover:scale-105 text-sm uppercase tracking-wide">
              Programează-te acum
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>

          {/* Compozitie Grafica Compacta */}
          <div className="hidden md:flex flex-1 relative h-40 items-center justify-center">
            {/* Card Permis */}
            <div className="absolute right-12 top-2 w-56 h-32 bg-white/10 backdrop-blur-md border border-white/30 rounded-xl shadow-lg p-3 transform rotate-6 hover:rotate-0 transition-all duration-300 z-10">
              <div className="flex justify-between items-start border-b border-white/20 pb-1.5 mb-1.5">
                <div className="text-[9px] font-bold text-white uppercase">Permis de Conducere</div>
                <div className="flex gap-1"><div className="w-3 h-1.5 bg-blue-600"></div><div className="w-3 h-1.5 bg-yellow-400"></div><div className="w-3 h-1.5 bg-red-600"></div></div>
              </div>
              <div className="flex gap-2 mt-2">
                <div className="w-12 h-16 bg-slate-300/50 rounded-sm"></div>
                <div className="space-y-1.5 flex-1 mt-1">
                  <div className="h-1.5 bg-white/40 rounded w-full"></div>
                  <div className="h-1.5 bg-white/40 rounded w-3/4"></div>
                  <div className="h-1.5 bg-white/40 rounded w-1/2"></div>
                </div>
              </div>
            </div>

            {/* Card Certificat */}
            <div className="absolute left-8 bottom-0 w-56 h-32 bg-blue-900/50 backdrop-blur-md border border-blue-400/30 rounded-xl shadow-lg p-3 transform -rotate-3 hover:rotate-0 transition-all duration-300 z-20">
               <div className="text-[9px] font-bold text-yellow-400 uppercase border-b border-blue-400/30 pb-1.5 mb-2">Certificat de Înmatriculare</div>
               <div className="space-y-2 mt-3">
                  <div className="flex justify-between"><div className="h-1.5 bg-blue-200/50 rounded w-1/4"></div><div className="h-1.5 bg-blue-200/50 rounded w-1/2"></div></div>
                  <div className="flex justify-between"><div className="h-1.5 bg-blue-200/50 rounded w-1/4"></div><div className="h-1.5 bg-blue-200/50 rounded w-1/3"></div></div>
                  <div className="flex justify-between"><div className="h-1.5 bg-blue-200/50 rounded w-1/4"></div><div className="h-1.5 bg-blue-200/50 rounded w-2/3"></div></div>
               </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scurtaturi Rapide */}
      <div className="grid md:grid-cols-3 gap-4">
        <Link to="/permise" className="group">
          <Card className="border-slate-200 shadow-sm hover:shadow-md transition-all hover:border-blue-300 h-full">
            <CardHeader className="bg-slate-50 p-4 border-b border-slate-100 group-hover:bg-blue-50 transition-colors flex flex-row items-center gap-3">
              <div className="p-2 bg-blue-600 rounded-lg text-white group-hover:scale-105 transition-transform">
                <CreditCard className="w-5 h-5" />
              </div>
              <CardTitle className="text-base text-slate-800 m-0">Permise Auto</CardTitle>
            </CardHeader>
            <CardContent className="p-4">
              <p className="text-xs text-slate-600">Aflați actele necesare pentru eliberarea primului permis, preschimbarea documentului expirat sau modificarea datelor.</p>
            </CardContent>
          </Card>
        </Link>

        <Link to="/inmatriculari" className="group">
          <Card className="border-slate-200 shadow-sm hover:shadow-md transition-all hover:border-blue-300 h-full">
            <CardHeader className="bg-slate-50 p-4 border-b border-slate-100 group-hover:bg-blue-50 transition-colors flex flex-row items-center gap-3">
              <div className="p-2 bg-blue-600 rounded-lg text-white group-hover:scale-105 transition-transform">
                <Car className="w-5 h-5" />
              </div>
              <CardTitle className="text-base text-slate-800 m-0">Înmatriculări</CardTitle>
            </CardHeader>
            <CardContent className="p-4">
              <p className="text-xs text-slate-600">Informații complete despre înmatriculări permanente, radieri, numere provizorii sau transcrierea dreptului de proprietate.</p>
            </CardContent>
          </Card>
        </Link>

        <Link to="/examinari" className="group">
          <Card className="border-slate-200 shadow-sm hover:shadow-md transition-all hover:border-blue-300 h-full">
            <CardHeader className="bg-slate-50 p-4 border-b border-slate-100 group-hover:bg-blue-50 transition-colors flex flex-row items-center gap-3">
              <div className="p-2 bg-blue-600 rounded-lg text-white group-hover:scale-105 transition-transform">
                <FileText className="w-5 h-5" />
              </div>
              <CardTitle className="text-base text-slate-800 m-0">Examinări</CardTitle>
            </CardHeader>
            <CardContent className="p-4">
              <p className="text-xs text-slate-600">Structura probelor teoretice pe categorii, locațiile sălilor de testare pe calculator și documentele pentru dosar.</p>
            </CardContent>
          </Card>
        </Link>
      </div>

      <div className="bg-amber-50 rounded-lg p-4 border border-amber-200 flex gap-3 mt-4 items-start">
        <Info className="w-6 h-6 text-amber-600 flex-shrink-0 mt-0.5" />
        <div>
          <h4 className="font-semibold text-amber-900 text-sm mb-1">Anunț important privind plățile</h4>
          <p className="text-xs text-amber-800 leading-relaxed">
            Contravaloarea documentelor (permise, certificate, plăcuțe) se poate achita rapid și sigur prin internet banking, mandate poștale sau direct pe <a href="https://www.ghiseul.ro" target="_blank" rel="noreferrer" className="font-bold underline hover:text-amber-700">ghișeul.ro</a>. Vă rugăm să aveți dovada plății la dumneavoastră în momentul prezentării.
          </p>
        </div>
      </div>
    </div>
  );
}
